import React, { useState, useEffect } from "react";
import { Table, Checkbox, Button, notification } from "antd";
import { updateRoles, getRoles } from "../api/user.service"; // Fetch & update roles API

const Roles = () => {
    const [roleAccess, setRoleAccess] = useState({});

    // Fetch roles from API on page load
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const data = await getRoles(); // Fetch roles from API
                setRoleAccess(data?.data); // Directly set the received JSON
            } catch (error) {
                notification.error({ message: "Failed to load roles" });
            }
        };
        fetchRoles();
    }, []);

    const handleAccessChange = (role, module) => {
        setRoleAccess((prev) => ({
            ...prev,
            [role]: {
                ...prev[role],
                [module]: !prev[role][module],
            },
        }));
    };

    const handleSubmit = async () => {
        try {
            const response = await updateRoles(roleAccess);
            notification.success({ message: response?.data?.msg || "Successfully updated" });
        } catch (error) {
            notification.error({ message: error?.response?.data?.message || "Failed to update" });
        }
    };

    const columns = [
        {
            title: "Role",
            dataIndex: "role",
            key: "role",
        },
        ...Object.keys(roleAccess?.[Object.keys(roleAccess)[0]] || {}).map((module) => ({
            title: module,
            dataIndex: module,
            key: module,
            render: (_, record) => (
                <Checkbox
                    checked={roleAccess?.[record.role]?.[module] || false}
                    onChange={() => handleAccessChange(record.role, module)}
                />
            ),
        })),
    ];

    const dataSource = Object.keys(roleAccess).map((role) => ({
        key: role,
        role,
    }));

    return (
        <div>
            <Table columns={columns} dataSource={dataSource} pagination={false} bordered scroll={{ x: "max-content" }} />

            <div className="flex justify-end mt-4">
                <Button type="primary" onClick={handleSubmit}>Save Changes</Button>
            </div>
        </div>
    );
};

export default Roles;
